import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { LanguageType } from '@icilalune/types';
import { MainMenuTreeItem } from '@nx-icilalune/data/icilalune/types';
import { TranslationItem, Tree } from '@nx-icilalune/drupal-types';

export const SETTINGS_CURRENT_LANGUAGE = new InjectionToken<
  Observable<LanguageType>
>('SETTINGS_CURRENT_LANGUAGE');

export const SETTINGS_APP_VERSION = new InjectionToken<string>(
  'SETTINGS_APP_VERSION'
);

export const SETTINGS_APP_INSTALLED = new InjectionToken<Observable<boolean>>(
  'SETTINGS_APP_INSTALLED'
);

export const SETTINGS_CAN_INSTALL = new InjectionToken<Observable<boolean>>(
  'SETTINGS_CAN_INSTALL'
);

export const SETTINGS_MENU = new InjectionToken<
  Observable<Tree<MainMenuTreeItem>>
>('SETTINGS_MENU');

export const SETTINGS_ROUTED_ALTERNATIVES_MENU = new InjectionToken<
  Observable<TranslationItem[]>
>('SETTINGS_ROUTED_ALTERNATIVES_MENU');
